/**
 * Extensões aceitas no canal de transcrição por anexo de texto no composer
 * (spec-010-r2-guiada-pelo-agente-com-transcricao, [T006], US-4).
 *
 * Espelho MANUAL de `aawz_transcriptions/utils/upload_texto_transcricao.py::
 * EXTENSOES_ACEITAS` — o backend é quem valida de verdade, e uma extensão
 * aceita aqui e recusada lá (ou o contrário) faz o composer prometer um envio
 * que o servidor recusa em seguida.
 */
export const EXTENSOES_CANAL_TRANSCRICAO = ['.txt', '.md', '.vtt', '.docx']
